import React, { FunctionComponent, useEffect } from "react";
import { Theme, makeStyles, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Background } from "../../components/container/background";
import { LoginCard } from "./login-card";
import { AssetManager } from "../../theme/asset-manager";
import { LoginContextProvider } from "./context/login-context";
import { useHistory } from "react-router";
import { useUser } from "../../components/user/user-context";
import { ROUTES } from "../../router/router";
import { ShopButton } from "../../components/shop-button/shop-button";

export const LOGIN_CARD_WIDTH = 610;

const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    width: LOGIN_CARD_WIDTH * 0.6,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  logoContainer: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100vw",
    },
  },
  logoDescription: {
    color: theme.palette.primary.main,
    fontWeight: 400,
    fontSize: 19.5,
    marginRight: theme.spacing(2),
  },
  heading: {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  pageWrapper: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flex: 1,
    margin: 0,
    [theme.breakpoints.down("md")]: {
      width: `calc(100vw - ${theme.spacing(4)} )`,
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: "initial",
    },
  },
  card: {
    padding: theme.spacing(6),
    width: LOGIN_CARD_WIDTH,
    maxWidth: LOGIN_CARD_WIDTH,
    [theme.breakpoints.down("sm")]: {
      width: `calc(100vw - ${theme.spacing(40)}px)`,
    },
    [theme.breakpoints.down("xs")]: {
      width: `calc(100vw - ${theme.spacing(20)}px)`,
    },
  },
  spacingTop: {
    marginTop: theme.spacing(5),
  },
  shopButtonContainer: {
    position: "fixed",
    width: "auto",
    zIndex: 1101,
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      position: `relative`,
    },
  },
}));

interface ILoginPageProps {}

export const LoginPage: FunctionComponent<ILoginPageProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { isLoggedIn } = useUser();

  useEffect(() => {
    history.replace({ search: "" });
  }, [history]);

  useEffect(() => {
    if (isLoggedIn()) {
      history.push(ROUTES.PORTAL.PATH);
    }
  }, [history, isLoggedIn]);

  return (
    <Background showSkeleton>
      <Grid container className={classes.pageWrapper} justify="center" alignItems="center" direction="column">
        <Grid item className={classes.logoContainer}>
          <img src={AssetManager.Logo.DigitalTwin} alt="" className={classes.logo} />
          <Typography align="center" className={classes.logoDescription}>
            {t("general.create_your_own_personal_digital_twin")}
          </Typography>
        </Grid>
        <Grid item className={classes.spacingTop}>
          <Typography className={classes.heading}>{t("login.welcome")}!</Typography>
        </Grid>
        <Grid item className={classes.spacingTop}>
          <LoginContextProvider>
            <LoginCard className={classes.card} />
          </LoginContextProvider>
        </Grid>
        <Grid item className={classes.shopButtonContainer}>
          <ShopButton mobileBubbleAnchor="center" />
        </Grid>
      </Grid>
    </Background>
  );
};
